export default __webpack_public_path__ + "static/media/finder-icon.1f65e2b1.png";